<template>
  <div :class="`time-input time-input--${size}`">
    <div class="time-input__child">
      <icon type="ios-arrow-up" @click="add_hour" />
      <input
        :class="`ivu-input ivu-input-${size}`"
        type="number"
        :value="time.hour_format"
        @input.prevent="change_hour"
      />
      <icon type="ios-arrow-down" @click="sub_hour" />
    </div>

    <div class="time-input__child">
      :
    </div>

    <div class="time-input__child">
      <icon type="ios-arrow-up" @click="add_minute" />
      <input
        :class="`ivu-input ivu-input-${size}`"
        type="number"
        :value="time.minute_format"
        @input.prevent="change_minute"
      />
      <icon type="ios-arrow-down" @click="sub_minute" />
    </div>
  </div>
</template>

<script>
  import { Time } from './input-time-block-class';

  export default {
    props: {
      value: {
        type: String,
        default: '0:0'
      },

      size: {
        type: String,
        default: 'normal'
      }
    },

    data() {
      return {
        time: new Time(this.value)
      };
    },

    computed: {},

    watch: {
      value: {
        handler: function(current) {
          const t = new Time(current);
          if (current !== t.toString()) {
            this.$emit('input', t.toString());
          }
        },
        immediate: true
      }
    },

    methods: {
      add_hour() {
        this.time.hour++;
        this.emit();
      },

      sub_hour() {
        this.time.hour--;
        this.emit();
      },

      add_minute() {
        this.time.minute += 5;
        this.emit();
      },

      sub_minute() {
        this.time.minute -= 5;
        this.emit();
      },

      change_hour(e) {
        this.time.hour = parseInt(e.target.value);
        this.emit();
      },

      change_minute(e) {
        this.time.minute = parseInt(e.target.value);
        this.emit();
      },

      emit() {
        this.$emit('input', this.time.toString());
      }
    }
  };
</script>

<style lang="scss">
  .time-input {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__child {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      width: 100%;

      .ivu-icon:hover {
        cursor: pointer;
      }

      input {
        text-align: center;
      }
    }

    &--large {
      font-size: 17px;
      font-weight: bold;
    }
  }
</style>
